/*
 * @Author: yuanxing(01407381)
 * @Date: 2023-02-24 10:31:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-12-07 11:35:18
 * @FilePath: \ibu-owt-core-frontend\site\nav\index.js
 * @Description: 右侧导航
 */
import allUrls from '@/utils/config'

// cn=中文，en=英语，th=泰语，韩文：ko  日文：ja 泰文：th   越语：vi   繁体：tw
const config = {
  cn: {
    navList: [
      {
        id: 3,
        name: 'navs.customerService',
        icon: 'customerService',
      },
      {
        id: 4,
        name: 'navs.businessCooperationBlank',
        icon: 'businessCooperation',
      },
      {
        id: 6, // 功能反馈
        name: 'navs.funcSuggestionBlank',
        icon: 'suggestion',
      },
      {
        id: 5,
        name: 'navs.wechatNo',
        icon: 'wechat',
        src: require('~/assets/img/footer/ic_qrcode_wechat.jpg'),
      },
    ],
    tabList: [
      {
        id: 1,
        name: 'modules.home.broadside.name1',
        type: 'express',
      },
      {
        id: 2,
        name: 'modules.home.broadside.name2',
        type: 'ec',
      },
      {
        id: 3,
        name: 'modules.home.broadside.name3',
        type: 'sfbuy',
      },
    ],
    kefu: '',
    customerUrl: allUrls.iuopCustomerUrl,
  },
  sg: {
    navList: [
      {
        id: 3,
        name: 'navs.customerService',
        icon: 'customerService',
      },
      {
        id: 4,
        name: 'navs.businessCooperationBlank',
        icon: 'businessCooperation',
      },
      {
        id: 6, // 功能反馈
        name: 'navs.funcSuggestionBlank',
        icon: 'suggestion',
      },
    ],
    tabList: [],
    kefu: {
      sc: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=QV7ZraFZvIVj&showChat=true&layout=true',
      en: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=eQZrieBnmqee&showChat=true&layout=true',
    },
    customerUrl: allUrls.iuopGlobalCustomerUrl,
  },
  my: {
    navList: [
      {
        id: 3,
        name: 'navs.customerService',
        icon: 'customerService',
      },
      {
        id: 4,
        name: 'navs.businessCooperationBlank',
        icon: 'businessCooperation',
      },
      {
        id: 6, // 功能反馈
        name: 'navs.funcSuggestionBlank',
        icon: 'suggestion',
      },
    ],
    tabList: [],
    kefu: {
      sc: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=EFVZn2ZniQNf&showChat=true&layout=true',
      en: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=aiUjMveMJFNv&showChat=true&layout=true',
    },
    customerUrl: allUrls.iuopGlobalCustomerUrl,
  },
  in: {
    navList: [
      // {
      //   id: 3,
      //   name: 'navs.customerService',
      //   icon: 'customerService',
      // },
      {
        id: 4,
        name: 'navs.businessCooperationBlank',
        icon: 'businessCooperation',
      },
      {
        id: 6, // 功能反馈
        name: 'navs.funcSuggestionBlank',
        icon: 'suggestion',
      },
    ],
    tabList: [],
    kefu: {
      sc: 'https://kefu.sf.global/webim/im.html?configId=4e230b4a-29de-4a6e-b361-6912d041cc1b&lang=cn',
      en: 'https://kefu.sf.global/webim/im.html?configId=4e230b4a-29de-4a6e-b361-6912d041cc1b&lang=en',
    },
    customerUrl: allUrls.iuopGlobalCustomerUrl,
  },
  eu: {
    navList: [
      // {
      //   id: 3,
      //   name: 'navs.customerService',
      //   icon: 'customerService',
      // },
      {
        id: 4,
        name: 'navs.businessCooperationBlank',
        icon: 'businessCooperation',
      },
      // {
      //   id: 6, // 功能反馈
      //   name: 'navs.funcSuggestionBlank',
      //   icon: 'suggestion',
      // },
    ],
    tabList: [],
    kefu: {
      sc: 'https://wa.me/31643249528/?text=Hello%EF%BC%81+This+is+your+dedicated+service+rep%21',
      en: 'https://wa.me/31643249528/?text=Hello%EF%BC%81+This+is+your+dedicated+service+rep%21',
    },
    customerUrl: allUrls.iuopGlobalCustomerUrl,
  },
  th: {
    navList: [
      {
        id: 3,
        name: 'navs.customerService',
        icon: 'customerService',
      },
      {
        id: 4,
        name: 'navs.businessCooperationBlank',
        icon: 'businessCooperation',
      },
      {
        id: 6, // 功能反馈
        name: 'navs.funcSuggestionBlank',
        icon: 'suggestion',
      },
    ],
    tabList: [],
    kefu: {
      sc: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=uIvArefE3I32&showChat=true&layout=true',
      en: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=ENVjAnr2yYna&showChat=true&layout=true',
      th: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=aEBVFjvquAVr&showChat=true&layout=true',
    },
    customerUrl: allUrls.iuopGlobalCustomerUrl,
  },
  id: {
    navList: [
      {
        id: 3,
        name: 'navs.customerService',
        icon: 'customerService',
      },
      {
        id: 4,
        name: 'navs.businessCooperationBlank',
        icon: 'businessCooperation',
      },
      {
        id: 6, // 功能反馈
        name: 'navs.funcSuggestionBlank',
        icon: 'suggestion',
      },
    ],
    tabList: [
      {
        id: 4,
        name: 'modules.home.broadside.name4', // 国际件
        type: 'international',
      },
      {
        id: 5,
        name: 'modules.home.broadside.name5', // 本地件
        type: 'domestic',
      },
    ],
    // kefu: {
    //   sc: '/id/sc/support/service',
    //   en: '/id/en/support/service',
    // },
    customerUrl: allUrls.iuopGlobalCustomerUrl,
  },
  ph: {
    navList: [
      // {
      //   id: 3,
      //   name: 'navs.customerService',
      //   icon: 'customerService',
      // },
      {
        id: 4,
        name: 'navs.businessCooperationBlank',
        icon: 'businessCooperation',
      },
      {
        id: 6, // 功能反馈
        name: 'navs.funcSuggestionBlank',
        icon: 'suggestion',
      },
    ],
    tabList: [],
    // kefu: {
    //   sc: '/id/sc/support/service',
    //   en: '/id/en/support/service',
    // },
    customerUrl: allUrls.iuopGlobalCustomerUrl,
  },
  vn: {
    navList: [
      {
        id: 3,
        name: 'navs.customerService',
        icon: 'customerService',
      },
      {
        id: 4,
        name: 'navs.businessCooperationBlank',
        icon: 'businessCooperation',
      },
      {
        id: 6, // 功能反馈
        name: 'navs.funcSuggestionBlank',
        icon: 'suggestion',
      },
      {
        id: 5,
        name: 'navs.wechatNo',
        icon: 'wechat',
        src: require('~/assets/img/footer/vn_qrcode_wechat.jpg'),
      },
    ],
    tabList: [],
    kefu: {
      sc: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=6bYVfa777bQr&showChat=true&layout=true',
      en: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=FJNRBr7RFFFj&showChat=true&layout=true',
      vi: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=yuuIb2zYJJfi&showChat=true&layout=true',
    },
    customerUrl: allUrls.iuopGlobalCustomerUrl,
  },
  jp: {
    navList: [
      {
        id: 4,
        name: 'navs.businessCooperationBlank',
        icon: 'businessCooperation',
      },
      {
        id: 6, // 功能反馈
        name: 'navs.funcSuggestionBlank',
        icon: 'suggestion',
      },
      {
        id: 3,
        name: 'navs.customerService',
        icon: 'customerService',
      },
    ],
    tabList: [],
    kefu: {
      sc: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=Uf6rqqvuaIva&showChat=true&layout=true',
      en: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=jEjARzeeummi&showChat=true&layout=true',
      ja: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=mURRje2EZFFn&showChat=true&layout=true',
    },
    customerUrl: allUrls.iuopGlobalCustomerUrl,
  },
  au: {
    navList: [
      {
        id: 4,
        name: 'navs.businessCooperationBlank',
        icon: 'businessCooperation',
      },
      // {
      //   id: 6, // 功能反馈
      //   name: 'navs.funcSuggestionBlank',
      //   icon: 'suggestion',
      // },
      {
        id: 3,
        name: 'navs.customerService',
        icon: 'customerService',
      },
    ],
    tabList: [],
    kefu: {
      sc: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=ryueqevQz6za&showChat=true&layout=true',
      en: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=VreeaqyIn2qm&showChat=true&layout=true',
    },
    customerUrl: allUrls.iuopGlobalCustomerUrl,
  },
  kr: {
    navList: [
      {
        id: 3,
        name: 'navs.customerService',
        icon: 'customerService',
      },
      {
        id: 4,
        name: 'navs.businessCooperationBlank',
        icon: 'businessCooperation',
      },
      {
        id: 6, // 功能反馈
        name: 'navs.funcSuggestionBlank',
        icon: 'suggestion',
      },
    ],
    tabList: [],
    kefu: {
      sc: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=mUR3meaIFNRr&showChat=true&layout=true',
      en: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=ymymimmiayIb&showChat=true&layout=true',
      ko: 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=beIJvuRJ3Eja&showChat=true&layout=true',
    },
    customerUrl: allUrls.iuopGlobalCustomerUrl,
  },
  gb: {
    navList: [
      {
        id: 3,
        name: 'navs.customerService',
        icon: 'customerService',
      },
      {
        id: 4,
        name: 'navs.businessCooperationBlank',
        icon: 'businessCooperation',
      },
      {
        id: 6, // 功能反馈
        name: 'navs.funcSuggestionBlank',
        icon: 'suggestion',
      },
    ],
    tabList: [],
    kefu: {
      sc: 'https://kefu.sf.global/webim/im.html?configId=1fd82e7f-c0a2-4bb7-905d-3ec7a7016f90&lang=cn',
      en: 'https://kefu.sf.global/webim/im.html?configId=01bcfb07-f2a0-4d5b-8b8f-9b2c61b1fdcd&lang=en',
    },
    customerUrl: allUrls.iuopGlobalCustomerUrl,
  },
  us: {
    navList: [
      {
        id: 3,
        name: 'navs.customerService',
        icon: 'customerService',
      },
      {
        id: 4,
        name: 'navs.businessCooperationBlank',
        icon: 'businessCooperation',
      },
      {
        id: 6, // 功能反馈
        name: 'navs.funcSuggestionBlank',
        icon: 'suggestion',
      },
    ],
    tabList: [],
    kefu: {
      sc: 'https://kefu.sf.global/webim/im.html?configId=11d7e380-55ac-44eb-a70b-fd208f9ebbb7&lang=cn',
      en: 'https://kefu.sf.global/webim/im.html?configId=060d52d3-ab8a-4664-a271-9d02683989e4&lang=en',
    },
    customerUrl: allUrls.iuopGlobalCustomerUrl,
  },
}

export default config
